import React, {useEffect} from 'react'
import {SetSetting} from 'entities/settings'
import {useUser} from 'entities/user'
import {getColor, mediaVariants} from 'shared/lib'
import {currentMirror} from 'shared/mirrors/config'
import {FreshChatTags} from './config'

const SCRIPT_ID = 'Freshchat-js-sdk'

export const FreshChatOpenSupport = () => {
  if (!window.fcWidget.isOpen()) {
    window.fcWidget.open()
  }
}

const onCloseFreshChat = () => {
  window.fcWidget.on('widget:closed', () => {
    window.fcWidget.setTags([FreshChatTags.support])
  })
}

export const FreshChatOpenHideTag = () => {
  window.fcWidget.setTags([FreshChatTags.hideAccount])

  FreshChatOpenSupport()
  onCloseFreshChat()
}

export const FreshChatOpenDeactivationTag = () => {
  window.fcWidget.setTags([FreshChatTags.deleteAccount])

  FreshChatOpenSupport()
  onCloseFreshChat()
}

export const FreshChatOpenPaymentTag = () => {
  window.fcWidget.setTags([FreshChatTags.declinedPayment])

  FreshChatOpenSupport()
  onCloseFreshChat()
}

export const FreshChat = () => {
  const user = useUser()

  useEffect(() => {
    const initFreshChat = () => {
      const restoreId = user.settings ? user.settings.restoreId : null

      const {avatarUrl, gender, country, email, name, dateBirth} = user.profile

      const userUpdate = () => {
        window.fcWidget.user.update({
          profilePicUrl: avatarUrl + mediaVariants.square64,
          firstName: name,
          email: email,
          meta: {
            cf_country: country,
            cf_gender: gender,
            cf_date_of_birth: dateBirth,
            cf_ts: user.support.ts,
            cf_lt: user.support.lt,
            cf_mirror: currentMirror
          }
        })
      }

      window.fcWidget.init({
        token: '2f1d12e5-aecc-4c95-b9ea-073e49b6c90c',
        host: 'https://carewise.freshchat.com',
        externalId: user.id,
        restoreId,
        tags: [FreshChatTags.support],
        config: {
          headerProperty: {
            backgroundColor: `rgb(${getColor('appPrimary500Rgb')})`,
            hideChatButton: true
          }
        }
      })

      userUpdate()

      if (!restoreId) {
        window.fcWidget.on('user:created', (resp: any) => {
          const status = resp && resp.status
          const data = resp && resp.data

          if (status === 200) {
            data.restoreId && SetSetting('restoreId', data.restoreId).catch(console.error)
          }

          userUpdate()
        })
      }
    }

    const initiateCall = () => {
      if (document.getElementById(SCRIPT_ID) && window.fcWidget) return initFreshChat()

      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = 'https://carewise.freshchat.com/js/widget.js'
      script.onload = initFreshChat
      document.head.appendChild(script)
    }

    if (user.support.enabled) {
      initiateCall()
    }

    return () => {
      window.fcWidget?.destroy()
    }
  }, [])

  return <></>
}
